import { Segment } from "semantic-ui-react";
import "./SubscriptionLevelTable.scss";
import { formatCurrency, isNumber } from "controls/utils";
import { tableRows } from "components/Authentication/SignUpForm/types";

export const SubscriptionLevelTable = () => {
  const headerClass = "table__header";

  return (
    <>
      <Segment>
        <div className="table">
          {_.map(tableRows, (e, idx) => (
            <div
              className={`table__data  ${idx === 0 && headerClass}`}
              key={idx}
            >
              {_.map(e, (field, id) => (
                <span
                  key={id}
                  className={`${
                    idx === 0 ? "table__header__field" : "table__data__field"
                  } ${field?.style}`}
                >
                  {isNumber(field.value)
                    ? formatCurrency(field.value)
                    : field.value}
                </span>
              ))}
            </div>
          ))}
        </div>
      </Segment>
    </>
  );
};
